import {
    MDBBreadcrumb,
    MDBBreadcrumbItem,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane
} from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";
import { Navigate, useLocation, useNavigate } from 'react-router';
import { getSpecificFreshDeskProfile } from '../apiclients/streamsapi_bridge';
import APISettings from '../components/editviews/freshDesk/APISettings';
import APIUser from '../components/editviews/freshDesk/APIUser';
import TopSuccess from '../components/header/TopSuccess';
import TopMessage from '../components/header/TopMessage';
import { useAdminContext } from '../components/adminstore/Admin-Context';
import EditWarning from '../components/header/EditWarning';



function APIDetails(props) {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const previewRef = useRef(null);
    const { isEdited, setEdited } = useAdminContext();
    const [targetView, setTargetView] = useState("");
    const [showWarning, setShowWarning] = useState(false);
    const warningToggle = () => setShowWarning(!showWarning);

    const handleDragOver = (event) => {
        event.preventDefault();
        document
            .getElementById("uploadFile")
            .parentNode.classList.add("draging", "dragBox");
    };

    const handleDrop = (event) => {
        event.preventDefault();
        document
            .getElementById("uploadFile")
            .parentNode.classList.remove("draging");
        document.getElementById("uploadFile").parentNode.classList.add("dragBox");
        const file = event.dataTransfer.files[0];
        previewImage(file);
    };

    const previewImage = (file) => {
        const previewDiv = previewRef.current;

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const previewImage = document.createElement("img");
                previewImage.src = reader.result;
                previewDiv.innerHTML = "";
                previewDiv.appendChild(previewImage);
            };
            reader.readAsDataURL(file);
        } else {
            previewDiv.innerHTML = "";
        }
    };
    const [centredModal, setCentredModal] = useState(false);

    const basicData = {
        columns: [
            { label: "Event Type", field: "name", sort: true },
            { label: "Date", field: "Address" },
            { label: "Caller Name", field: "contact" },
            { label: "Dialed Number", field: "number" },
            { label: "Agent-ID /Email-ID", field: "Devices" },
            { label: "Transaction ID", field: "Delete" },
            { label: "Response", field: "Delete" },
            { label: "Status", field: "Delete", sort: false },
        ],
        rows: [
            ['PSTN Inbound Call Accepted', '03/19/2024 09:23:56', '	[V] San Francis CA ()', '	+19252080673', 'nikhilone/raghu@pandorarndlabs.com', '1321791985', '	Ticket ID: 10', 'success'],
            ['PSTN Inbound Call Accepted', '03/19/2024 09:23:56', '	[V] San Francis CA ()', '	+19252080673', 'nikhilone/raghu@pandorarndlabs.com', '1321791985', '	Ticket ID: 10', 'success'],
            ['PSTN Inbound Call Accepted', '03/19/2024 09:23:56', '	[V] San Francis CA ()', '	+19252080673', 'nikhilone/raghu@pandorarndlabs.com', '1321791985', '	Ticket ID: 10', 'success'],
            ['PSTN Inbound Call Accepted', '03/19/2024 09:23:56', '	[V] San Francis CA ()', '	+19252080673', 'nikhilone/raghu@pandorarndlabs.com', '1321791985', '	Ticket ID: 10', 'success'],
        ],
    };
    const toggleOpen = () => setCentredModal(!centredModal);

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        if (isEdited) {
            setTargetView(value);
            setShowWarning(true);
            return;
        }

        setBasicActive(value);
    };

    const handleOk = () => {
        setEdited(false);
        if (targetView.indexOf("/") !== -1) {
            navigate(targetView);
        } else {
            setBasicActive(targetView);
        }
        setShowWarning(false);
    };

    const [AddNumbers, setAddNumbers] = useState(false);
    const toggleShow12 = () => setAddNumbers(!AddNumbers);
    const [verticalActive, setVerticalActive] = useState("tab1");
    const handleVerticalClick = (value) => {
        if (value === verticalActive) {
            return;
        }

        setVerticalActive(value);
    };

    const section1 = useRef(null);
    const section2 = useRef(null);
    const section3 = useRef(null);
    const containerRef = useRef(null);


    // const actionData = {
    //     columns: [
    //         { label: "Name", field: "user" },
    //         { label: "AgentID", field: "email" },
    //         { label: "Email ID", field: "role" },
    //         { label: "FreshDesk Notification Pop-up", field: "admin" },
    //         { label: "Remove", field: "remove", sort: false },
    //     ],
    //     rows: [
    //         {
    //             user: "",
    //             email: "",
    //             role: "",
    //             admin: "",
    //             remove: "",
    //         }
    //     ],
    // };

    // const [addUserTeam, setAddUserTeam] = useState(false);
    // const addUserToggle = () => setAddUserTeam(!addUserTeam);

    const navigate = useNavigate();
    const location = useLocation();
    const [profileInfo, setprofileInfo] = useState(
        location.state ? location.state.profileInfo ? location.state.profileInfo : location.state : {}
    );

    const tab = location.state && location.state.tab ? location.state.tab + "" : "tab1";

    const [basicActive, setBasicActive] = useState(tab);


    const [profileInfoObj, setprofileInfoObj] = useState();
    const [isloading, setIsloading] = useState(false);
    const [reRender, setReRender] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");




    // Fetches the specific profile information.
    async function getSpecificProfile() {
        try {
            setIsloading(true);
            const response = await getSpecificFreshDeskProfile(JSON.parse(sessionStorage.getItem("admin_session")).siteid, profileInfo.profileid);
            setTimeout(() => { setIsloading(false) }, 1000);
            if (!response.json) {
                const message = `An error has occured: ${response.statusText}`;
                return;
            }
            let rawData = await response.json();
            if (!rawData) {
                window.alert(`info with id  not found`);
                navigate("/");
            }
            setprofileInfoObj({ ...rawData.profile_details, profileid: profileInfo.profileid });
            console.log(`profileInfoObj is :::: ${JSON.stringify({ ...rawData.profile_details })}`)
            setReRender(false);
        } catch (e) {
            console.log(`Unable to load the sepcific group info:${e}`);
        }
    }

    useEffect(() => {
        if (profileInfo.profileid || reRender) {
            getSpecificProfile();
        }
    }, [profileInfo.profileid, reRender]);

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);


    return (
        <React.Fragment>
            <>
                <MainLinks active={6} />
                <Body
                    tablinks={6}
                    sublink={4}
                    content={
                        <>

                            <section className="mb-3">
                                <div className="card card-height">

                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0">
                                            <MDBBreadcrumb>
                                                <MDBBreadcrumbItem>
                                                    <a
                                                        onClick={(e) => {
                                                            if (isEdited) {
                                                                setTargetView("/accountinfolanding");
                                                                setShowWarning(true);
                                                                return;
                                                            }
                                                            navigate("/accountinfolanding");
                                                        }}
                                                    >
                                                        <strong>{t("AdminTools")}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    <a
                                                        onClick={(e) => {
                                                            if (isEdited) {
                                                                setTargetView("/apilanding");
                                                                setShowWarning(true);
                                                                return;
                                                            }
                                                            navigate("/apilanding");
                                                        }}
                                                    >
                                                        <strong>{t("APIs")}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem>
                                                    <a href="">
                                                        <strong>{profileInfoObj?.profile_name}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                            </MDBBreadcrumb>
                                        </h5>
                                    </div>
                                    <div className="card-body px-0">
                                        <div className="pb-2">
                                            <h5 className="mt-2 ">
                                                {profileInfoObj?.profile_name}
                                            </h5>
                                            <p className="mt-2 text-secondary">
                                                {profileInfo.profile_type}
                                            </p>
                                        </div>

                                        <MDBTabs className='mb-3'>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                    {t("api")}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                                                    {t("users")}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        </MDBTabs>

                                        <MDBTabsContent>
                                            <MDBTabsPane open={basicActive === 'tab1'}>
                                                <APISettings
                                                    profileInfo={profileInfoObj}
                                                    profileInfoObj={profileInfo}
                                                    setIsloading={setIsloading}
                                                    setReRender={setReRender}
                                                    setSuccessMessage={setSuccessMessage}
                                                    setEdited={setEdited}
                                                />
                                            </MDBTabsPane>
                                            <MDBTabsPane open={basicActive === 'tab2'} >

                                                <APIUser
                                                    profileInfo={profileInfoObj}
                                                    profileInfoObj={profileInfo}
                                                    setSuccessMessage={setSuccessMessage}
                                                    setIsloading={setIsloading}
                                                    setEdited={setEdited}

                                                />
                                            </MDBTabsPane>
                                        </MDBTabsContent>
                                    </div>
                                </div>
                            </section>
                        </>
                    }

                />
                {successMessage && (
                    <>
                        <TopSuccess>
                            <TopMessage successMessage={successMessage} />
                        </TopSuccess>
                    </>
                )}

                {showWarning && (
                    <EditWarning
                        warningToggle={warningToggle}
                        setShowWarning={setShowWarning}
                        onOk={handleOk}
                    />
                )}
            </>
        </React.Fragment>
    );
}

export default APIDetails;
